module.exports = __webpack_public_path__ + "assets/images/CHF1000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CHF1000.png
// module id = 1338
// module chunks = 1